// app/composables/query.ts

import type { LocationQuery } from "vue-router";

type Query = Record<string, string | number>;

type HandleQueriesOpts = {
  replace: boolean;
};

const defaultOpts: HandleQueriesOpts = {
  replace: false,
};

interface UseRouteQuery {
  addQuery: (query: Query, handleQueriesOpts?: HandleQueriesOpts) => void;
  deleteQuery: (query: string | string[], handleQueriesOpts?: HandleQueriesOpts) => void;
}

export function useRouteQuery(): UseRouteQuery {
  return {
    addQuery,
    deleteQuery,
  };
}

function addQuery(newQuery: Query, handleQueriesOpts?: HandleQueriesOpts) {
  const route = useRoute();
  const router = useRouter();

  try {
    if (route.query) {
      const options = handleQueriesOpts ? { ...defaultOpts, ...handleQueriesOpts } : defaultOpts;
      const currentQuery = JSON.parse(JSON.stringify(route.query));
      const _query = { ...currentQuery, ...newQuery };
      Object.keys(_query)
        .sort()
        .forEach((key, index, array) => {
          const aux = _query[key];
          delete _query[key];
          _query[key] = aux;
        });

      if (_query) {
        options.replace ? router.replace({ query: _query }) : router.push({ query: _query });
      }
    }
  } catch (e) {
    console.error(e);
  }
}

function deleteQuery(queryName: string | string[], handleQueriesOpts?: HandleQueriesOpts) {
  const route = useRoute();
  const router = useRouter();

  if (route.query) {
    try {
      const options = handleQueriesOpts ? { ...defaultOpts, ...handleQueriesOpts } : defaultOpts;
      const _query: LocationQuery = JSON.parse(JSON.stringify(route.query));

      if (typeof queryName === "string") {
        delete _query[queryName];
      } else {
        queryName.forEach(q => {
          delete _query[q];
        });
      }

      if (_query) {
        options.replace ? router.replace({ query: _query }) : router.push({ query: _query });
      }
    } catch (e) {
      console.error(e);
    }
  }
}
